import parse from "html-react-parser"
import { brandLogoSvg } from "shared/utils/ifttt_logo"

export default function IftttLogoIcon() {
  return (
    <span className="svg-icon">{parse(brandLogoSvg({ on: "dark" }))}</span>
  )
}
